module.exports = __webpack_public_path__ + "c706fd00a6e90559ae0536d16a09c09a.jpg";